<template>
  <div id="full-codec">
    <h1>{{ title }}</h1>
    <div>
      <p>
        Bemani Codec supports the encryption and decryption of
        <code>mulist</code>,
        <code>nolist</code>, and the files inside
        <code>.jbt</code> and
        <code>.rb</code> packages for jubeat plus, jubeat AC, REFLEC BEAT plus, and RB minus (RBAC).
      </p>
      <form method="post" enctype="multipart/form-data" @submit="validateForm">
        <table>
          <tr>
            <th colspan="2">Key Type</th>
          </tr>
          <tr>
            <td>
              <input type="radio" name="key-type" id="JBT" value="JBT" v-model="keyType" required />
              <label for="JBT">JBT</label>
            </td>
            <td>
              <label for="JBT">
                <code>.jbt</code> package files; jubeat AC (~
                <code>v3.7.0</code>)
                <code>mulist</code>; RB minus (RBAC)
                <code>mulist</code> and
                <code>nolist</code>
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input type="radio" name="key-type" id="JBT2" value="JBT2" v-model="keyType" />
              <label for="JBT2">JBT2</label>
            </td>
            <td>
              <label for="JBT2">
                <code>.jbt</code> package files (legacy)
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input type="radio" name="key-type" id="JBT_EDIT" value="JBT_EDIT" v-model="keyType" />
              <label for="JBT_EDIT">JBT_EDIT</label>
            </td>
            <td>
              <label for="JBT_EDIT">
                jubeat plus: edit; jubeat AC (
                <code>v3.9.1</code>)
                <code>mulist</code>
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="key-type"
                id="JBT_NETWORK"
                value="JBT_NETWORK"
                v-model="keyType"
              />
              <label for="JBT_NETWORK">JBT_NETWORK</label>
            </td>
            <td>
              <label for="JBT_NETWORK">jubeat plus: network</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="key-type"
                id="JBT_OTHERS"
                value="JBT_OTHERS"
                v-model="keyType"
              />
              <label for="JBT_OTHERS">JBT_OTHERS</label>
            </td>
            <td>
              <label for="JBT_OTHERS">jubeat plus: others</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="key-type"
                id="JBT_SP"
                value="JBT_SP"
                v-model="keyType"
              />
              <label for="JBT_SP">JBT_SP</label>
            </td>
            <td>
              <label for="JBT_SP">jubeat SP <code>mulist</code></label>
            </td>
          </tr>
          <tr>
            <td>
              <input type="radio" name="key-type" id="RB" value="RB" v-model="keyType" />
              <label for="RB">RB</label>
            </td>
            <td>
              <label for="RB">
                <code>.rb</code> package files
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input type="radio" name="key-type" id="RB2" value="RB2" v-model="keyType" />
              <label for="RB2">RB2</label>
            </td>
            <td>
              <label for="RB2">
                <code>.rb</code> package files (legacy)
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="key-type"
                id="RB_OTHERS"
                value="RB_OTHERS"
                v-model="keyType"
              />
              <label for="RB_OTHERS">RB_OTHERS</label>
            </td>
            <td>
              <label for="RB_OTHERS">REFLEC BEAT plus: others</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="key-type"
                id="RB_SAVE_DATA"
                value="RB_SAVE_DATA"
                v-model="keyType"
              />
              <label for="RB_SAVE_DATA">RB_SAVE_DATA</label>
            </td>
            <td>
              <label for="RB_SAVE_DATA">REFLEC BEAT plus: save data key</label>
            </td>
          </tr>
          <tr>
            <td>
              <input type="radio" name="key-type" id="CUSTOM" value="CUSTOM" v-model="keyType" />
              <label for="CUSTOM" id="custom-label">CUSTOM</label>
            </td>
            <td>
              <input
                type="text"
                :pattern="keyPattern"
                maxlength="36"
                placeholder="Custom key (leave blank for empty string)"
                name="mulist-key"
                id="custom-key"
                v-model="customKeyValue"
                @click="clickId('custom-label')"
                @change="clickId('custom-label')"
              />
              <div>
                <input
                  type="checkbox"
                  v-model="verifyUuid"
                  id="verify-uuid"
                  @click="clickId('custom-label')"
                  @change="clickId('custom-label')"
                />
                <label
                  for="verify-uuid"
                  @click="clickId('custom-label')"
                  @change="clickId('custom-label')"
                >Verify UUID (all caps)</label>&nbsp;
                <input
                  type="checkbox"
                  name="ensure-bom"
                  id="ensure-bom"
                  @click="clickId('custom-label')"
                  @change="clickId('custom-label')"
                />
                <label
                  for="ensure-bom"
                  @click="clickId('custom-label')"
                  @change="clickId('custom-label')"
                >Ensure <code>UTF-8 BOM</code> for processing.</label>
              </div>
            </td>
          </tr>
          <tr>
            <th colspan="2">
              Files
              <code>[20MB maximum]</code>
            </th>
          </tr>
          <tr>
            <td colspan="2">
              <input
                type="radio"
                name="get-nolist"
                v-model="getNolist"
                id="check-choose-file"
                required
                checked
                :value="false"
                @click="chooseFile"
              />
              <input
                type="file"
                name="file"
                id="file-chooser"
                @click="getNolist = false"
                @change="handleFile"
                multiple
                required
              />
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="get-nolist"
                id="get-nolist"
                v-model="getNolist"
                :value="true"
              />
              <label for="get-nolist">Get nolist</label>
            </td>
            <td>
              <label for="get-nolist">
                Obtain an encrypted
                <code>nolist</code> and ignore all other options
              </label>
            </td>
          </tr>
          <tr>
            <th colspan="2">Option</th>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                v-model="encode"
                id="encrypt"
                name="encrypt"
                :value="true"
                required
              />
              <label for="encrypt">Encrypt</label>
            </td>
            <td>
              <label for="encrypt">
                If multiple files are selected, the returned zip file will have its
                <code>MD5</code> value appended at the end.
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input type="radio" v-model="encode" id="decrypt" name="encrypt" :value="false" />
              <label for="decrypt">Decrypt</label>
            </td>
          </tr>
          <tr v-if="errors.length">
            <th colspan="2" class="error">Error(s)</th>
          </tr>
          <tr v-if="errors.length">
            <td colspan="2" class="error">
              <ul>
                <li v-for="error in errors" v-bind:key="`error-${error.code}`">{{ error.msg }}</li>
              </ul>
            </td>
          </tr>
        </table>
        <input type="submit" value="Submit" v-show="files.length > 0 || getNolist" />
      </form>
    </div>
    <footer>
      <pre>BEMANI CODEC COMES WITH ABSOLUTELY NO WARRANTY, USE AT YOUR OWN RISK.</pre>
    </footer>
  </div>
</template>

<script>
export default {
  name: "BemaniCodec",
  data: () => ({
    files: [],
    keyType: "JBT",
    customKeyValue: "",
    encode: true,
    verifyUuid: true,
    getNolist: false,
    errors: [],
  }),
  computed: {
    keyPattern: function () {
      return this.verifyUuid
        ? "[a-fA-F\\d]{8}-[a-fA-F\\d]{4}-[a-fA-F\\d]{4}-[a-fA-F\\d]{4}-[a-fA-F\\d]{12}"
        : "*";
    },
  },
  watch: {
    getNolist: function () {
      console.log(this.getNolist);
      const fileChooser = document.getElementById("file-chooser");
      if (!this.getNolist) {
        fileChooser.setAttribute("required", "required");
        fileChooser.setAttribute("name", "file");
      } else {
        fileChooser.removeAttribute("required");
        fileChooser.removeAttribute("name");
      }
    },
  },
  methods: {
    clickId(labelId) {
      document.getElementById(labelId).click();
    },
    chooseFile() {
      document.getElementById("file-chooser").click();
    },
    handleFile(event) {
      this.files = event.target.files;
    },
    validateForm(event) {
      this.errors = [];

      if (this.keyType == "") {
        this.errors.push({ code: 1, msg: "Key type required!" });
      }
      if (!this.getNolist) {
        if (this.files.length === 0) {
          this.errors.push({
            code: 2,
            msg: "File needed unless getting nolist!",
          });
        } else {
          let size = 0;
          for (let file of this.files) {
            size += file.size;
            console.log(file.size);
          }
          if (size > 20971520)
            // file exceeds 20MB
            this.errors.push({
              code: 3,
              msg: "Total file size exceeds 20MB!",
            });
        }
      }

      if (!this.errors.length) return true;
      event.preventDefault();
    },
  },
  props: {
    title: String,
  },
};
</script>

<style scoped>
.content {
  margin: 0 auto;
}

p,
ul,
li {
  margin: 0;
}

td,
th {
  vertical-align: top;
  text-align: start;
}

tr:not(:first-of-type) th {
  padding-top: 10px;
}

input {
  font-family: monospace;
}

input + label,
input + input {
  padding-left: 3px;
  font-family: monospace;
}

td + td {
  padding-left: 10px;
  overflow-x: auto;
}

.error {
  color: crimson;
}

#custom-key {
  width: 350px;
}

footer,
pre {
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
</style>